/* Raihan Rugs Cinematic — theme.js */
(function(){
  'use strict';
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal (both .rr-reveal and .rr-fade-stagger)
  function initReveal() {
    var els = document.querySelectorAll('.rr-reveal, .rr-fade-stagger');
    if (!els.length) return;
    if (rm) {
      els.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function(el){ io.observe(el); });
  }

  // Random product shuffle (varies products shown on each page load)
  function initProductShuffle() {
    var grids = document.querySelectorAll('[data-rr-shuffle]');
    grids.forEach(function(grid){
      var children = Array.prototype.slice.call(grid.children);
      if (children.length <= 1) return;
      // Fisher-Yates shuffle the DOM order
      for (var i = children.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        // Move children[j] to be next sibling of children[i] in DOM
        if (i !== j) {
          grid.insertBefore(children[j], children[i].nextSibling);
          // swap in array too
          var tmp = children[i]; children[i] = children[j]; children[j] = tmp;
        }
      }
      // Add class so CSS reveals new ordering correctly
      grid.classList.add('rr-mp-shuffled');
    });
  }

  // Number count-up
  function initCountUp() {
    var els = document.querySelectorAll('[data-rr-count]');
    if (!els.length || rm) {
      els.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-rr-count'), 10);
          var suffix = el.getAttribute('data-rr-count-suffix') || '';
          if (isNaN(target)) { el.classList.add('is-visible'); io.unobserve(el); return; }
          var duration = 1400;
          var start = null;
          el.classList.add('is-visible');
          function step(ts){
            if (!start) start = ts;
            var p = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased) + suffix;
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    els.forEach(function(el){ io.observe(el); });
  }

  // Sticky CTA bar
  function initStickyCTA() {
    var cta = document.querySelector('[data-rr-sticky-cta]');
    if (!cta) return;
    var threshold = 0.5;
    var visible = false;
    function check() {
      var doc = document.documentElement;
      var scrolled = (window.scrollY || doc.scrollTop) / ((doc.scrollHeight - doc.clientHeight) || 1);
      var shouldShow = scrolled > threshold && scrolled < 0.92;
      if (shouldShow !== visible) {
        visible = shouldShow;
        cta.classList.toggle('is-visible', visible);
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  function initMobileNav() {
    var toggle = document.querySelector('[data-rr-nav-toggle]');
    var nav = document.querySelector('[data-rr-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function(){
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  function initMegaMenu() {
    var items = document.querySelectorAll('[data-rr-mega]');
    if (!items.length) return;
    items.forEach(function(item){
      var trigger = item.querySelector('[data-rr-mega-trigger]');
      var panel = item.querySelector('[data-rr-mega-panel]');
      if (!trigger || !panel) return;
      var timer;
      function open() { clearTimeout(timer); item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
      function close() { timer = setTimeout(function(){ item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }, 220); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      trigger.addEventListener('focus', open);
      panel.addEventListener('focusout', function(e){
        if (!item.contains(e.relatedTarget)) close();
      });
    });
  }

  function init() {
    initProductShuffle();
    initReveal();
    initCountUp();
    initStickyCTA();
    initMobileNav();
    initMegaMenu();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
